// This file is AUTOGENERATED, do not edit it manually!!!

export const users = {
    active: 'Activo',
    active_switch_description: 'Al desactivar la propiedad Activo del usuario, haces dos cosas: liberas una licencia para otro usuario y haces que el usuario inactivo sea invisible en todo el sistema excepto en la página de Usuarios.',
    add_user: 'Agregar usuario',
    apply: 'Aplicar',
    assign: 'Agregar',
    assigned_activities_menu_title: 'Actividades asignadas',
    can_login: 'Puede iniciar sesión',
    can_login_switch_description: 'Al desactivar Puede iniciar sesión, solo deniegas al usuario el acceso al sistema. El usuario aún puede ser miembro o asignado en un proyecto. Esta acción también liberará una licencia si la necesitas.',
    cancel: 'Cancelar',
    CanDenyLogin_User_DenyLoginYourself: 'No puedes desactivar Puede iniciar sesión para ti mismo.',
    CanDenyLogin_User_LastAdministrator: 'No puedes desactivar Puede iniciar sesión para un usuario que es el único administrador en el sistema.',
    CanDisable_User_DisableYourself: 'No puedes desactivar Activo para ti mismo.',
    CanDisable_User_LastAdministrator: 'No puedes desactivar Activo para un usuario que es el único administrador en el sistema.',
    cant_delete_user: 'El usuario \"{0}\" no puede ser eliminado',
    cant_login: 'No puede iniciar sesión',
    change_password: 'Cambiar contraseña',
    close: 'Cerrar',
    convert_title: 'Convertir',
    convert_to_regular: 'Convertir en usuario regular',
    convert_to_regular_title: 'Convertir {0} en usuario regular con el rol:',
    convert_to_regular_title_with_job_role: 'Convertir {0} en usuario regular con el puesto de trabajo:',
    deactivate: 'Hacer inactivo',
    deactivateTitle: 'Cambiar estatus del usuario a Inactivo',
    delete: 'Eliminar',
    delete_confirm: '¿Eliminar usuario \"{0}\"?',
    delete_skill_title: 'Eliminar habilidad',
    delete_team_title: 'Eliminar equipo',
    DeleteRateBtnTitle: 'Eliminar permanentemente',
    Disable_Permission_Message: 'Estás a punto de desactivar un permiso en tu rol que te permite editar tus propios permisos y los de otros usuarios.',
    Disable_Permission_Title: 'Ya no podrás editar los permisos de los usuarios.',
    DisplayName_customerId: 'Cliente',
    DisplayName_email: 'Correo electrónico',
    DisplayName_hourlyRate: 'Tarifa de facturación por hora',
    DisplayName_hourlyRateInternal: 'Tarifa interna por hora',
    DisplayName_login: 'Inicio de sesión',
    email: 'E-mail',
    exclude: 'Excluir',
    filterbystatus_Active: 'Solo activos',
    filterbystatus_All: 'Activos e inactivos',
    filterbystatus_CannotLogin: 'Solo no pueden iniciar sesión',
    filterbystatus_Inactive: 'Solo inactivos',
    generate: 'Generar',
    guest_portal_title: 'Portal de invitados.',
    guests_interaction: 'Los invitados solo pueden interactuar con el sistema a través de',
    guests_license: 'No requieren licencia.',
    guests_users_tab_title: 'Invitados',
    import_title: 'Importar',
    inactive: 'Inactivo',
    jobroles_updated_successfully: 'Los puestos de trabajo se han actualizado correctamente',
    lastActivityDate_title: 'Última visita',
    licensing_limits_warning: 'No puedes permitir que este usuario inicie sesión porque tu licencia no permite agregar más usuarios que puedan iniciar sesión.',
    name_column_title: 'Nombre',
    no_sercurity_logs: 'Este usuario aún no tiene registros',
    password_changed: 'La contraseña ha sido cambiada.',
    personal_schedule_title: 'Horario personal',
    regular_users_tab_title: 'Regulares',
    reload: 'Actualizar',
    remove_confirm: '¿Eliminar usuario?',
    reset: 'Asignar',
    reset_password_confirmation: 'Al hacer clic en \"Generar\" se generará una nueva contraseña y se enviará por correo electrónico al usuario.',
    reset_password_done: 'La nueva contraseña ha sido generada y enviada.',
    reset_password_menu_title: 'Generar y enviar contraseña por e-mail',
    reset_password_title: '¿Realmente deseas generar y enviar la nueva contraseña por e-mail?',
    reset_permissions_confirmation: 'Una vez asignado, el usuario tendrá el rol actual en todos los proyectos donde sea miembro. Esta operación no se puede deshacer.',
    reset_permissions_done: 'El rol actual ha sido asignado.',
    reset_permissions_menu: 'Asignar rol actual',
    reset_permissions_title: '¿Deseas asignar el rol actual a todos los proyectos del usuario?',
    security_logs_action: 'Acción',
    security_logs_date: 'Fecha',
    security_logs_modal_title: 'Registro de seguridad de',
    security_logs_title: 'Registro de seguridad',
    securitylog_msg_GuestConverted: 'Rol cambiado de Invitado a {0} por {1}.',
    securitylog_msg_LoginChanged: 'El inicio de sesión fue cambiado por el usuario {0}.',
    securitylog_msg_LoginChangedBySelf: 'El inicio de sesión fue cambiado.',
    securitylog_msg_PasswordChanged: 'La contraseña fue cambiada por el usuario {0}.',
    securitylog_msg_PasswordChangedByRecovery: 'La contraseña fue recuperada.',
    securitylog_msg_PasswordChangedBySelf: 'La contraseña fue cambiada.',
    securitylog_msg_PasswordGenerated: 'La contraseña fue generada por el usuario {0}.',
    securitylog_msg_PasswordGeneratedBySelf: 'La contraseña fue generada.',
    securitylog_msg_PasswordIncorrect: 'Contraseña incorrecta.',
    securitylog_msg_RecoveryRequest: 'Solicitud de recuperación.',
    securitylog_msg_RoleChanged: 'El rol cambió de {0} a {1} por {2}.',
    securitylog_msg_UserLockout: 'El usuario fue bloqueado después de intentos de contraseña inválidos.',
    securitylog_msg_UserLockoutDueToInactivity: 'El usuario fue bloqueado por inactividad.',
    securitylog_msg_UserUnlocked: 'El usuario fue desbloqueado por el usuario {0}.',
    selected_users: '1#{0} usuario seleccionado#{0} usuarios seleccionados',
    Set_skills: 'Agregar habilidades',
    Set_teams: 'Equipos',
    show: 'Mostrar',
    show_other_reasons: 'Mostrar otros motivos',
    skills: 'Habilidades',
    skills_updated_successfully: 'Las habilidades se han actualizado correctamente',
    skillsDeleteConfirm: 'La habilidad será eliminada de los perfiles de otros usuarios donde se esté usando',
    spaces: 'Espacios',
    suggest_deactivate: 'Sin embargo, tienes la opción de inactivar al usuario, lo que eliminará su visibilidad en {brandName}, excepto en la página de Usuarios y en el historial de asignaciones de proyectos y tareas. Esta acción liberará una licencia para otro usuario.',
    teams: 'Equipos',
    teams_updated_successfully: 'Los equipos se han actualizado correctamente',
    teamsDeleteConfirm: 'El equipo se eliminará de los equipos de cada usuario',
    TimerText: '1#{0} segundo#{0} segundos',
    unlock: 'Desbloquear',
    user_conversion_done: '{0} se ha convertido correctamente.',
    user_conversion_title: 'Conversión de usuario',
    user_duplicate_email_error: 'Ya existe un usuario con el correo electrónico especificado',
    user_duplicate_login_error: 'Ya existe un usuario con el inicio de sesión especificado',
    user_licensing_limits_warning: 'No puedes activar Puede iniciar sesión para este usuario ya que no hay más licencias disponibles.',
    User_NotFound_Title: 'Usuario solicitado no encontrado',
    userRates: 'Historial de tarifas',
    userRates_changed_by: 'Cambiado por',
    userRates_date: 'Fecha de cambio',
    userRates_hourlyRate: 'Tarifa por hora facturable',
    userRates_hourlyRateInternal: 'Tarifa interna por hora',
    userRates_title: 'Historial de tarifas para {0}',
};
